import { extractLastNameComponentFromName } from '@spotify/confidence-core-react';

export const makeCollectionName = (collectionId: string) =>
  `collections/${collectionId}`;

export const makeFavoritesCollectionId = (identityName: string) => {
  const identityId = extractLastNameComponentFromName(identityName);
  return `favorites-${identityId}`;
};

export const deriveFavoritesCollectionName = (identityName: string) =>
  makeCollectionName(makeFavoritesCollectionId(identityName));
